export default button => {

    let isExpanded = false;

    const onClick = () => {
        const target = document.getElementById(button.getAttribute('aria-controls'));
        if (!isExpanded) {
            target.style.display = 'block';
        } else {
            target.style.display = '';
        }
        isExpanded = !isExpanded;
        button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    };

    const init = () => {
        button.addEventListener('click', onClick);
    };

    const destroy = () => {
        button.removeEventListener('click', onClick);
    };

    return {
        init,
        destroy
    };

};
